import { apiClient } from '@/services/apiClients'

export const logout = () => apiClient.post(`/api/logout`)
